const UTM_PREFIX = "utm_";
const UTM_SOURCE_KEY = "utm_source";
const SEO_SOURCE = "seo";

export function getUtmMetadataFromSearch(search, options = {}) {
  const params = new URLSearchParams(search || "");

  const maxKeys = Number.isFinite(options.maxKeys) ? options.maxKeys : 50;
  const maxKeyLength = Number.isFinite(options.maxKeyLength)
    ? options.maxKeyLength
    : 40;
  const maxValueLength = Number.isFinite(options.maxValueLength)
    ? options.maxValueLength
    : 500;

  /** @type {Record<string, string>} */
  const utm = {};

  for (const [rawKey, rawValue] of params.entries()) {
    const key = String(rawKey || "");
    if (!key) continue;
    if (!key.toLowerCase().startsWith(UTM_PREFIX)) continue;

    const value = rawValue == null ? "" : String(rawValue);
    if (!value) continue;

    const safeKey = key.slice(0, maxKeyLength);
    const safeValue = value.slice(0, maxValueLength);

    // Note: duplicates overwrite earlier values, which is fine for metadata.
    utm[safeKey] = safeValue;

    if (Object.keys(utm).length >= maxKeys) break;
  }

  return utm;
}

export function isOrganicOrSeoTraffic(search = "") {
  const params = new URLSearchParams(search || "");
  let hasNonEmptyUtm = false;
  const utmSources = [];

  for (const [rawKey, rawValue] of params.entries()) {
    const key = String(rawKey || "").toLowerCase();
    if (!key.startsWith(UTM_PREFIX)) continue;

    const value = rawValue == null ? "" : String(rawValue).trim();
    if (!value) continue;

    hasNonEmptyUtm = true;
    if (key === UTM_SOURCE_KEY) {
      utmSources.push(value.toLowerCase());
    }
  }

  return (
    !hasNonEmptyUtm ||
    (utmSources.length > 0 &&
      utmSources.every((value) => value === SEO_SOURCE))
  );
}
